import React, { useState,useEffect } from 'react'
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import DataTable from 'react-data-table-component';


const PendingCallChat = () => {
const[summerydata,setSummeryData]=useState([])
 const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
 
  const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [astroName, setAstroName] = useState("");
       const [timeoutId, setTimeoutId] = useState(null);

const fetchSummeryData=async()=>{
  const post={AstrologerName:astroName,Datetimefrom:startTime,Datetimeto:endTime,State:null} // in state we pass call or chat for filter
  try {
     const res=await AddUpdate ("ChatHistory/PendingList",post)
   
    
   
      const data=JSON.parse(res?.data?.data)
      const finaldata=data?.Table
   
      setSummeryData(finaldata)
     

  } catch (error) {
     console.log("error",error)
  }
}

  const columns = [
    {
      name: "Astro Name",
      selector: (row) => row.AstroName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div
          
        >
          <div>
            {row.AstroName}({row.AstroID})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.AstroPhone}
          </div>
        </div>
      ),
    },
    
    {
      name: "UserName",
      selector: (row) => row.UserName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div
         
        >
          <div>
            {row.UserName}({row.UserID})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.UserPhone}
          </div>
        </div>
      ),
    },
   
    {
      name: "Type",
      selector: (row) => row.Type? row.Type:"null",
      sortable: true,
    },
   {
      name: "Rate",
      selector: (row) => row.Rate,
      sortable: true,
      
    },
   
    {
      name: "DateTime",
      selector: (row) => row.CreatedTime?row.CreatedTime:"null",
      sortable: true,
    }

  
  ];

 useEffect(()=>{
    fetchSummeryData()
  },[])


useEffect(() => {
    if (
      astroName.length < 3 
    
    )
      return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
     
      fetchSummeryData()
  
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [astroName]);




const handleSearch = () => {
    setSummeryData([]); 
    if (startTime ) {
      const formatDate = (dateTime) => {
        if (!dateTime) return null;
        const date = new Date(dateTime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = formatDate(startTime);
      const formattedEndDate = formatDate(endTime);

      const data = {
        FromDate: formattedStartDate,
        Todate: formattedEndDate,
      };

       
        fetchSummeryData()
    }
  };
  return (
   <>

  <div className="form-group  main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Pending Call/Chat List</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
           
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>
       
        <div className="row mt-3 ">
          
           <div className="col-3">
            <label className="form-label">Astrologer Name</label>
            <input
              type="text"
            
              value={astroName}
              placeholder="Enter Astrologer name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setAstroName(input);
                }
              }}
            />
            {astroName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

       

          <div className="col-auto">
            <button className="btn btn-primary ms-2 mt-3" onClick={handleSearch}>
              Search
            </button>
          
          </div>
        </div>
      </div>

 <div className="col-12 mt-2  main_card">
        
          <DataTable
            dense
            data={summerydata || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            customStyles={customStyles}
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
       
      </div>

   </>
  )
}

export default PendingCallChat;